import TeachingBubbleExample from "./examples/TeachingBubble.Example";
import TextOnlyTeachingBubbleExample from "./examples/TextOnly.TeachingBubble.Example";
import SeriesTeachingBubbleExample from "./examples/Series.TeachingBubble.Example";

export default [
    {
        title: "Basic teaching bubble",
        component: TeachingBubbleExample,
        code: require("!raw-loader!./examples/TeachingBubble.Example.tsx")
    },
    {
        title: "Text only teaching bubble",
        component: TextOnlyTeachingBubbleExample,
        code: require("!raw-loader!./examples/TextOnly.TeachingBubble.Example.tsx")
    },
    {
        title: "Series of teaching bubbles",
        component: SeriesTeachingBubbleExample,
        code: require("!raw-loader!./examples/Series.TeachingBubble.Example.tsx")
    }
];
